"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
// Login where username + password are submitted in same request
exports.login = (username, password, baseurl, realm, tree, name) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + '/' + name + '/json' + realm + '/authenticate';
    const headers = {
        'Accept-API-Version': 'resource=2.0',
        'Content-Type': 'application/json'
    };
    const params = {
        'authIndexType': 'service',
        'authIndexValue': tree
    };
    const callbacks = yield exports.getCallbacks(url, headers, params);
    const loginPayload = exports.processCallbacks(callbacks, username, password);
    const loginResponse = yield exports.sendLoginPayload(loginPayload, url, headers, params);
    return loginResponse;
});
// Checks if username belongs to an account
exports.checkUsername = (username, sourceApp, baseurl, realm, tree, name) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + '/' + name + '/json' + realm + '/authenticate';
    const headers = {
        'Accept-API-Version': 'resource=2.0',
        'Content-Type': 'application/json'
    };
    const params = {
        'authIndexType': 'service',
        'authIndexValue': tree
    };
    // Makes initial call to get callbacks
    const callbacks = yield exports.getCallbacks(url, headers, params);
    const loginPayload = exports.processCallbacks(callbacks, username, sourceApp);
    // Sends callbacks back with user info
    const loginResponse = yield exports.sendLoginPayload(loginPayload, url, headers, params);
    return loginResponse;
});
// Checks if password is valid
exports.checkPassword = (password, callbacks, baseurl, realm, tree, name) => __awaiter(void 0, void 0, void 0, function* () {
    const url = baseurl + '/' + name + '/json' + realm + '/authenticate';
    const headers = {
        'Accept-API-Version': 'resource=2.0',
        'Content-Type': 'application/json'
    };
    const params = {
        'authIndexType': 'service',
        'authIndexValue': tree
    };
    const loginPayload = exports.processCallbackSingle(callbacks, password);
    const loginResponse = yield exports.sendLoginPayload(loginPayload, url, headers, params);
    return loginResponse;
});
// Makes initial request to AM to get callbacks
exports.getCallbacks = (url, headers, params) => __awaiter(void 0, void 0, void 0, function* () {
    return yield axios_1.default({
        headers,
        method: 'post',
        params,
        url
    }).then(response => {
        return {
            response: response.data,
            status: response.status
        };
    })
        .catch(err => {
        return {
            response: err.response.data,
            status: err.response.status
        };
    });
});
// Checks if a token was returned with callbacks from Forgerock AM
exports.checkToken = (callbacks) => {
    try {
        const tokenId = callbacks.response.tokenId;
        return true;
    }
    catch (_a) {
        return false;
    }
};
// Inserts user info into callbacks provided by AM
exports.processCallbacks = (callbacks, username, sourceApp) => {
    const loginPayload = callbacks.response;
    if (callbacks.status < 299) {
        loginPayload.callbacks[0].input[0].value = username;
        loginPayload.callbacks[1].input[0].value = sourceApp;
    }
    return loginPayload;
};
// Inserts user info into callbacks provided by AM
exports.processCallbackSingle = (callbacks, value) => {
    const loginPayload = callbacks.response;
    if (callbacks.status < 299) {
        try {
            loginPayload.callbacks[0].input[0].value = value;
        }
        catch (_a) {
            return loginPayload;
        }
    }
    return loginPayload;
};
// Submits callbacks w user info back to AM
exports.sendLoginPayload = (loginPayload, url, headers, params) => __awaiter(void 0, void 0, void 0, function* () {
    return yield axios_1.default({
        data: loginPayload,
        headers,
        method: 'post',
        params,
        url
    }).then(response => handleSuccessResponse(response)).catch(err => handleErrorResponse(err));
});
exports.parseToken = (token) => {
    const tokenDeconstructed = token.split('*');
    return {
        'jwt': tokenDeconstructed[2],
        'original': token,
        'ssoToken': tokenDeconstructed[1] + '*'
    };
};
const handleSuccessResponse = (resp) => __awaiter(void 0, void 0, void 0, function* () {
    return {
        'response': resp.data,
        'status': resp.status
    };
});
const handleErrorResponse = (error) => {
    if (error.response.status == 401) {
        try {
            return {
                'response': error.response.data,
                'status': error.response.status,
                'failureUrl': error.response.data.detail.failureUrl
            };
        }
        catch (_a) {
            return {
                'response': error.response.data,
                'status': error.response.status,
                'failureUrl': "/unknownerror"
            };
        }
    }
    else {
        return {
            'response': error.response.data,
            'status': error.response.status,
            'failureUrl': "/unknownerror"
        };
    }
};
